module.exports = __webpack_public_path__ + "static/img/38.d70a939.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/38.png
// module id = 0LUM
// module chunks = 1